export default __webpack_public_path__ + "static/media/4043238_avatar_boy_kid_person_icon@2x.3072cc01.png";